import { Card, CardContent } from '@/components/ui/card';
import { BookOpen, ExternalLink } from 'lucide-react';

const CATALOGUE_URL = 'https://kilobrochure-gyyvv4cq.manus.space/brochure.html';

export default function Resources() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-4xl font-bold tracking-tight mb-2" style={{ fontFamily: 'Outfit, sans-serif' }}>
          Resources
        </h1>
        <p className="text-muted-foreground">Access marketing materials and product information</p>
      </div>

      <Card className="border-2 border-orange-300 bg-gradient-to-r from-orange-50 to-orange-100/50 dark:from-orange-950/30 dark:to-orange-900/20">
        <CardContent className="py-6">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-4">
              <div className="p-3 rounded-lg bg-orange-500 text-white">
                <BookOpen className="h-6 w-6" />
              </div>
              <div>
                <h3 className="text-xl font-semibold">Product Catalogue</h3>
                <p className="text-muted-foreground">Browse our complete product range with pricing and details</p>
              </div>
            </div>
            <a 
              href={CATALOGUE_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center rounded-md text-sm font-medium bg-orange-500 hover:bg-orange-600 text-white h-10 px-4 py-2"
            >
              <ExternalLink className="h-4 w-4 mr-2" />
              View Catalogue
            </a>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
